// Copyright (c) Move Closer 2022.

import { Component, Vue, PropSync, Prop } from 'vue-property-decorator'

import { LinkProps } from '../../../../../dsl/atoms/Link'
/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
@Component({ name: 'AbstractSearchResults' })
export class AbstractSearchResults extends Vue {
  @Prop({ type: Array, required: true })
  public readonly elementsByGroups!: any

  @Prop({ type: Boolean, required: true })
  public readonly hasResults!: boolean

  @Prop({ type: Object, required: true })
  public readonly initialElements!: any

  @Prop({ type: Boolean, required: true })
  public readonly isLoading!: boolean

  @Prop({ type: String, required: true })
  public readonly phrase!: string

  @PropSync('isOpen', { type: Boolean, required: true })
  public _isOpen!: boolean

  @Prop({ type: Number, required: false })
  public searchFromChars!: number

  /**
   * Determines the link to search results page.
   */
  public get link (): LinkProps {
    return {
      target: {
        name: 'root.results',
        query: {
          q: this.phrase
        }
      },
      isDisabled: false,
      label: ''
    }
  }
}
export default AbstractSearchResults
